<template>
    <el-dialog
        :visible.sync="orderSuccessVisible"
        :show-close="false"
        center
        width="292px"
        class="order_success"
        :before-close="handleClose">
        <!-- <div class="order_success_title">选择优惠券</div> -->
        <div class="order_success_content">
            <img src="../../../assets/order/created_order.png" alt="">
            <p>下单成功</p>
        </div>
        <div class="order_success_btn">
            <el-button type="primary" @click="submit">确认</el-button>
        </div>
    </el-dialog>
   
</template>

<script>
export default {
    props:["orderSuccessVisible"],
   data (){
       return {

       }
   },
   components: {
       
   },
   watch: {
       
   },
   computed: { 
       
   },
   methods: { 
       submit(){
            this.$router.push({path:'/orderList'});
       },
       handleClose(){
           this.$emit('update:orderSuccessVisible',false);
       }
   },
   created() {

   },
   mounted() {
       
   }
}
</script>

<style scoped lang='less'>
.order_success{
    &_content{
        text-align:center;
        margin-top:42px;
        img{
            width:80px;
            height:80px;
        }
        p{
            font-size: 20px;
            color:#333333;
            font-weight: 500;
            margin-top:10px;
        }
    }
    &_title{
        font-size: 20px;
        color:#333;
        font-weight: 500;
        height: 28px;
        line-height: 28px;
        text-align: center;
    }
    &_btn{
        text-align:center;
        margin-top:24px;
        /deep/ .el-button{
            width:104px;
            height: 36px;
            padding: 10px 16px;
            margin-left: 5px;
            font-size: 16px;
            font-weight: 400;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/components/orderSuccess.vue